// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2beb0","large":"styles_large__1ZIcm"};